import { CheckCircleOutlined }    from '@ant-design/icons';
import { CloseCircleOutlined }    from '@ant-design/icons';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { withNavigation }         from 'components/App/withNavigation';
import { WithNavigationProps }    from 'components/App/withNavigation';
import dayjs                      from 'dayjs';
import React                      from 'react';
import { observer }               from 'mobx-react';
import { Link }                   from 'react-router-dom';
import { Table }                  from 'antd';
import { Button }                 from 'antd';
import { Popconfirm }             from 'antd';
import { PagedCollection }        from 'collections/PagedCollection';
import { privateLayoutStore }     from 'stores/index';
import { messageErrorIntl }       from 'utils/messageIntl';
import { messageSuccessIntl }     from 'utils/messageIntl';
import TopRightMenuWidgets        from '../menu/ListMenu';
import currentSession             from 'utils/currentSession';
import { ApiCollection }          from 'collections/ApiCollection';
import FormattedMessageWrapper    from 'components/App/FormattedMessageWrapper';
import ShowForm                   from 'forms/ShowForm';
import PageTitle                  from 'components/App/PageTitle';
import { ROLE_ORGANIZER }         from 'constants/RoleReferences';
import UserShowModel              from 'models/UserShowModel';
import type { ColumnsType }       from 'antd/es/table';
import ShowModel                  from 'models/ShowModel';
import UserModel                  from 'models/UserModel';
import { AppForm }                from 'components/App/AppForm';

interface OrganizerCellProps {
  organizerCollection: ApiCollection;
  show: ShowModel;
  userShowCollection: ApiCollection;
}

const OrganizerCell = observer(({
  organizerCollection,
  show,
  userShowCollection,
}: OrganizerCellProps) => {
  const userShow = userShowCollection.findBy('show.id', show.id) as UserShowModel;
  const organizer = organizerCollection.findBy('id', userShow?.userId) as UserModel;
  if (!organizer) {
    return '';
  }
  return organizer.fullName;
});

const initialSortedInfo = {
  columnKey: 'installationDateStart',
  order: 'descend',
};

@observer
class ShowList extends React.Component<WithNavigationProps> {
  public organizerCollection = new ApiCollection(UserModel);
  public showCollection = new PagedCollection(ShowModel);

  public state: {
    dataLoading: boolean;
    show: ShowModel;
    sortedInfo: any;
  } = {
      dataLoading: false,
      show: new ShowModel(),
      sortedInfo: initialSortedInfo,
    };

  public userShowCollection = new ApiCollection(UserShowModel);

  public componentDidMount() {
    if (!currentSession.isAdminOrSupport) {
      this.props.navigate('/404');
      return;
    }

    this.fetchData();
  }

  public render() {
    const { sortedInfo } = this.state;
    const columns: ColumnsType<any> = [
      {
        dataIndex: 'name',
        render: (_, model) => (
          <Link to={`/salons/${model.id}`}>
            <b>{model.get('name')}</b>
          </Link>
        ),
        sortDirections: ['descend', 'ascend'],
        // sorter: (a, b) => a.name === b.name,
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
        title: <FormattedMessageWrapper id="Nom" />,
      },
      {
        dataIndex: 'organizer',
        render: (_, model) => (
          <OrganizerCell
            organizerCollection={this.organizerCollection}
            show={model}
            userShowCollection={this.userShowCollection}
          />
        ),
        title: <FormattedMessageWrapper id="Organisateur" />,
      },
      {
        dataIndex: 'installationDateStart',
        render: date => dayjs(date).format('DD/MM/YYYY HH[h]mm'),
        sortDirections: ['descend', 'ascend'],
        // sorter: (a, b) => a.installationDateStart > b.installationDateStart,
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'installationDateStart' && sortedInfo.order,
        title: <FormattedMessageWrapper id="Début montage" />,
      },
      {
        dataIndex: 'installationDateEnd',
        render: date => dayjs(date).format('DD/MM/YYYY HH[h]mm'),
        sortDirections: ['descend', 'ascend'],
        // sorter: (a, b) => a.installationDateEnd > b.installationDateEnd,
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'installationDateEnd' && sortedInfo.order,
        title: <FormattedMessageWrapper id="Date fin montage" />,
      },
      {
        dataIndex: 'uninstallationDateStart',
        render: date => dayjs(date).format('DD/MM/YYYY HH[h]mm'),
        sortDirections: ['descend', 'ascend'],
        // sorter: (a, b) => a.uninstallationDateStart > b.uninstallationDateStart,
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'uninstallationDateStart' && sortedInfo.order,
        title: <FormattedMessageWrapper id="Date début démontage" />,
      },
      {
        dataIndex: 'uninstallationDateEnd',
        render: date => dayjs(date).format('DD/MM/YYYY HH[h]mm'),
        sortDirections: ['descend', 'ascend'],
        // sorter: (a, b) => a.uninstallationDateEnd > b.uninstallationDateEnd,
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'uninstallationDateEnd' && sortedInfo.order,
        title: <FormattedMessageWrapper id="Date fin démontage" />,
      },
      {
        dataIndex: 'organizerDeadline',
        render: date => dayjs(date).format('DD/MM/YYYY HH[h]mm'),
        sortDirections: ['descend', 'ascend'],
        // sorter: (a, b) => a.organizerDeadline > b.organizerDeadline,
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'organizerDeadline' && sortedInfo.order,
        title: <FormattedMessageWrapper id="Date limite documents" />,
      },
      {
        dataIndex: 'enabled',
        render: etat =>
          etat ? (
            <CheckCircleOutlined style={{ color: '#2ecc71' }} />
          ) : (
            <CloseCircleOutlined style={{ color: '#e74c3c' }} />
          ),
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => a.enabled - b.enabled,
        sortOrder: sortedInfo.columnKey === 'enabled' && sortedInfo.order,
        title: <FormattedMessageWrapper id="Etat" />,
      },
    ];

    if (currentSession.isGrantedRoleAdmin) {
      columns.push({
        dataIndex: 'actions',
        render: (_, record) => (
          <Popconfirm
            cancelText={<FormattedMessageWrapper id="Non" />}
            icon={<QuestionCircleOutlined style={{ color: '#e74c3c' }} />}
            okText={<FormattedMessageWrapper id="Oui" />}
            onCancel={event => event?.stopPropagation()}
            onConfirm={async event => {
              event?.stopPropagation();
              await this.deleteShow(record.get('id'));
            }}
            placement="left"
            title={<FormattedMessageWrapper id="Êtes-vous sûr de vouloir supprimer ce salon ?" />}
          >
            <Button
              htmlType="button"
              onClick={event => {
                event.stopPropagation();
              }}
            >
              <FormattedMessageWrapper id="Supprimer" />
            </Button>
          </Popconfirm>
        ),
        title: 'Actions',
      });
    }

    return (
      <>
        <div className="page-loading">
          {this.state.dataLoading && (
            <Button htmlType="button" loading>
              <FormattedMessageWrapper id="Chargement" />
            </Button>
          )}
        </div>

        <PageTitle
          title={<FormattedMessageWrapper id="Salons" />}
          topRightWidget={this.renderTopRightWidget()}
        />

        <div className="accented-shadow" style={contentStyle}>
          <Table
            columns={columns}
            dataSource={this.showCollection.models}
            onChange={this.onChange}
            onRow={record => ({
              onClick: () => {
                this.props.navigate(`/salons/${record.id}`);
              },
            })}
            pagination={{
              current: this.showCollection.page,
              defaultCurrent: 1,
              pageSize: this.showCollection.itemsPerPage,
              placement: ['topEnd', 'bottomEnd'],
              total: this.showCollection.total,
            }}
            rowKey={showModel => showModel.get('id')}
          />
        </div>
      </>
    );
  }

  public renderTopRightWidget = () => {
    return (
      <TopRightMenuWidgets
        handleMenuClick={() => {
          AppForm.open(ShowForm, {
            model: new ShowModel(),
            onSuccess: async () => {
              privateLayoutStore.fetchData();
              await this.fetchData();
            }
          }, {
            title: <FormattedMessageWrapper id="Ajouter un salon" />,
            width: 1024,
          });
        }}
        handleOnSearch={this.onSearch}
      />
    );
  };

  private deleteShow = async (id: string) => {
    this.setState({ dataLoading: true });

    const showModel = new ShowModel();

    showModel.set('id', id);

    try {
      await showModel.destroy();

      await this.fetchData();
      privateLayoutStore.fetchData();
      messageSuccessIntl("Salon supprimé !");
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }

    this.setState({ dataLoading: false });
  };

  private fetchData = async () => {
    this.setState({ dataLoading: true });

    await this.showCollection.setSort('installationDateStart', false).list();

    await this.userShowCollection
      .setFilters({
        show: this.showCollection.getUniques('id'),
        'user.role.reference': ROLE_ORGANIZER,
      })
      .list();

    await this.organizerCollection
      .setFilters({
        userShows: this.userShowCollection.getUniques('id'),
      })
      .list();

    this.setState({ dataLoading: false });
  };

  private onChange = (
      pagination: any,
      _filters: object,
      sorter: any,
  ) => {
    this.showCollection.setPage(pagination.current);

    Object.keys(this.showCollection.filters).forEach(key => {
      if (key.match(/order/g)) {
        delete this.showCollection.filters[key];
      }
    });

    if (typeof sorter.order !== 'undefined') {
      this.showCollection.setFilter(
        `order[${sorter.field}]`,
        sorter.order === true ? 'asc' : 'desc',
      );
    } else {
      // default order
      this.showCollection.setFilter('order[installationDateStart]', 'desc');
    }

    this.setState({ sortedInfo: sorter.columnKey ? sorter : initialSortedInfo }, this.fetchData);
  };

  private onSearch = async (value?: string) => {
    if (value !== '') {
      this.showCollection.setFilter('search', value);
    } else {
      delete this.showCollection.filters.search;
    }

    await this.fetchData();
  };
}

const contentStyle = { background: '#fff', minHeight: 360, padding: 24 };

const WrappedShowList = withNavigation(ShowList);

export default WrappedShowList;
